import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import Moment from 'moment';
import {
    getInvoiceLineItems,
    setInvoiceLineItemsError,
    setInvoiceLineItemsColSearchStr,
    setInvoiceLineItemsPageSize,
    sortInvoiceLineItems,
    resetInvoiceLineItems,
} from '../../../../constants/model-reducers/external/invoice/invoice/line-items.settings';

import { convertToFormatLocalDate, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
const defaultState = () => ({
    isInvoiceLineItemsLoaded: false,
    isInvoiceLineItemsError: false,
    invoiceLineItemsItems: DEFAULT_TABLE_RESULT_MODEL,
    invoiceLineItemsIsSortedAsc: false,
    IsSortAscending: false,

});

const initialState = defaultState();

export const invoiceLineItemsActions = {
    getInvoiceLineItems: (invoiceDetailsId, pageIndex) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName } = state().invoiceLineItems.invoiceLineItemsItems;
        var formData = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName, 
            IsSortAscending: false,
            TableFilterList: [],
        };
        var invoiceLineItems = await httpPost('external/invoice/getInvoicesLineItems', formData);
        if (invoiceLineItems.ok === false) {
            dispatch({
                type: setInvoiceLineItemsError,
                isInvoiceLineItemsError: true,
                isInvoiceLineItemsLoaded: false
            });
        } else {
            dispatch({
                type: getInvoiceLineItems,
                invoiceLineItemsItems: Object.keys(invoiceLineItems).length > 0 ? invoiceLineItems : DEFAULT_TABLE_RESULT_MODEL,
                isInvoiceLineItemsLoaded: true,
                isInvoiceLineItemsError: false
            });
        }
    },
    setInvoiceLineItemsColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { invoiceLineItemsItems } = state().invoiceLineItems;
        var invoiceLineItemsItemsUpd = {
            ...invoiceLineItemsItems,
            "Headers": {
                ...invoiceLineItemsItems.Headers,
                [key]: {

                    ...invoiceLineItemsItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInvoiceLineItemsColSearchStr,
            data: invoiceLineItemsItemsUpd,
            isInvoiceLineItemsError: false,
            isInvoiceLineItemsLoaded: true
        });
    },
    sortInvoiceLineItems: (columnClicked, isSortedAsc, invoiceDetailsId) => async (dispatch, state) => {
        const { Headers, Pagination, Data, SortedColumnName, IsSortAscending } = state().invoiceLineItems.invoiceLineItemsItems;
        const { invoiceLineItemsItems } = state().invoiceLineItems;
        var formData = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...invoiceLineItemsItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: [],
        };
        var invoiceLineItems = await httpPost('external/invoice/getInvoicesLineItems', formData);
        dispatch({
            type: sortInvoiceLineItems,
            invoiceLineItemsItems: invoiceLineItems,
            isInvoiceLineItemsLoaded: true,
            isInvoiceLineItemsError: false
        });
    },

    resizeLineItemsPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInvoiceLineItemsPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    extractInvoiceLineItems: (invoiceDetailsId) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, IsSortAscending } = state().invoiceLineItems.invoiceLineItemsItems;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Invoice Line item – ${formattedTimeZoneDate}`;
        var formData = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            FileName: filename,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: false,
            TableFilterList: [],
        };
        httpDownload('external/invoice/getInvoicesLineItemsExtractItems', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    extractEBillData: (invoiceId) => async (dispatch, state) => {

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} E-Bill Extract – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
       
        httpDownload("external/invoice/" + dealName + "/getEBillExtractData/" + invoiceId)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    resetInvoiceLineItems: () => (dispatch, state) => {
        dispatch({
            type: resetInvoiceLineItems
        })
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceLineItems:
            return {
                ...state,
                invoiceLineItemsItems: action.invoiceLineItemsItems,
                isInvoiceLineItemsLoaded: action.isInvoiceLineItemsLoaded,
                isInvoiceLineItemsError: action.isInvoiceLineItemsError
            };
        case setInvoiceLineItemsError:
            return {
                ...state,
                isInvoiceLineItemsError: action.isInvoiceLineItemsError,
                isInvoiceLineItemsLoaded: action.isInvoiceLineItemsLoaded
            }
        case setInvoiceLineItemsColSearchStr:
            return {
                ...state,
                invoiceLineItemsItems: action.data,
                isInvoiceLineItemsLoaded: action.isInvoiceLineItemsLoaded,
                isInvoiceLineItemsError: action.isInvoiceLineItemsError
            }
        case setInvoiceLineItemsPageSize:
            return {
                ...state,
                invoiceLineItemsItems: {
                    ...state.invoiceLineItemsItems,
                    Pagination: {
                        ...state.invoiceLineItemsItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case sortInvoiceLineItems:
            return {
                ...state,
                invoiceLineItemsItems: action.invoiceLineItemsItems,
                isInvoiceLineItemsLoaded: action.isInvoiceLineItemsLoaded
            }
        case resetInvoiceLineItems:
            return initialState;
        default:
            return state;
    }
};